export const navItems = [
	{
		title: 'mainMenu.statusOverview',
		icon: 'ei-menu-3',
		routerLink: '/statusoverview/statusoverview',
		minimumRole: 'User',
		minimumAdminRole: '',
		dropdown: false,
	},
	{
		title: 'mainMenu.citizenReport',
		icon: 'ti-bar-chart',
		routerLink: '/reports/citizen-report',
		minimumRole: 'ResidentViewer',
		minimumAdminRole: '',
		dropdown: false,
	},
	{
		title: 'mainMenu.citizen',
		icon: 'ti-user',
		routerLink: '/citizen/manage-citizens',
		minimumRole: 'ResidentViewer',
		minimumAdminRole: '',
		dropdown: false,
	},
	{
		title: 'mainMenu.careHome',
		icon: 'ti-home',
		dropdown: true,
		minimumRole: 'CarehomeEditor',
		minimumAdminRole: '',
		children: [
			{
				title: 'mainMenu.manageCareHome',
				routerLink: '/carehome/manage-carehome',
			},
			{
				title: 'mainMenu.manageDepartment',
				routerLink: '/carehome/manage-departments',
			},
		],
	},
	{
		title: 'mainMenu.careHomes',
		icon: 'ti-home',
		routerLink: '/carehomes',
		minimumRole: '',
		minimumAdminRole: 'Admin',
		dropdown: false,
	},
	{
		title: 'mainMenu.statistics',
		icon: 'ti-bar-chart',
		routerLink: '/statistics',
		minimumRole: '',
		minimumAdminRole: 'Admin',
		dropdown: false,
	},
	{
		title: 'mainMenu.devices',
		icon: 'ti-signal',
		routerLink: '/devices',
		minimumRole: '',
		minimumAdminRole: 'Admin',
		dropdown: false,
	},
	{
		title: 'mainMenu.manageDevices',
		icon: 'ti-mobile',
		routerLink: '/settings/manage-carehome-devices',
		minimumRole: '',
		minimumAdminRole: 'Admin',
		dropdown: false,
	},
	{
		title: 'mainMenu.diapers',
		icon: 'ti-settings',
		dropdown: true,
		minimumRole: '',
		minimumAdminRole: 'Admin',
		children: [
			{
				title: 'mainMenu.importDiapers',
				routerLink: '/diaper/import-diapers',
			},
			{
				title: 'mainMenu.diaperOverview',
				routerLink: '/diaper/diaper-overview',
			},
		],
	},
	{
		title: 'mainMenu.userManagement',
		minimumRole: 'Administrator',
		routerLink: '/carehome/current/users',
		icon: 'ti-user',
	},
	{
		icon: 'ti-user',
		minimumAdminRole: 'Admin',
		title: 'mainMenu.globalUserManagement',
		routerLink: '/userManagement/global',
	},
	{
		title: 'mainMenu.eventConfiguration',
		icon: 'ti-user',
		dropdown: true,
		minimumRole: '',
		minimumAdminRole: 'Admin',
		children: [
			{
				title: 'mainMenu.eventConfiguration',
				routerLink: '/eventConfiguration',
			},
			{
				title: 'mainMenu.manualEvents',
				routerLink: '/eventConfiguration/manual-events',
			},
		],
	},
	{
		title: 'mainMenu.eventGenerating',
		icon: 'ti-user',
		routerLink: '/eventGenerating',
		minimumRole: '',
		minimumAdminRole: 'Admin',
		dropdown: false,
	},
	{
		title: 'mainMenu.support',
		icon: 'ti-headphone-alt',
		externalLink: 'https://www.wearandcare.com/support',
		minimumRole: 'User',
		minimumAdminRole: 'Admin',
		dropdown: false,
	},
];